import React from "react";
import Navbar from "../components/LandingPageNew/Navbar";
import Footer from "../components/LandingPageNew/Footer";
import Blogs from "../components/Blog/Blogs";
import BottomRowCards from "../components/Blog/BottomRowCards";
const Counselore = () => {
  return (
    <div className="relative min-h-screen">
      {/* Navbar on top of hero */}
      <Navbar />
      <Blogs />
      <BottomRowCards/>

      <Footer />
    </div>
  );
};

export default Counselore;
